// F4 (mobile track): the technician app at /m. It has its own phone shell (not the desktop
// AppShell), so it is mounted by router.tsx as a top-level route rather than through `routes`.
import type { RouteObject } from 'react-router';

export const routes: RouteObject[] = [];
export const orgRoutes: RouteObject[] = [];

// Pages and shell come from one module (one chunk), so the service worker can keep all of it.
const app = () => import('./mobile-app');

export const mobileRoute: RouteObject = {
  path: '/m',
  lazy: async () => ({ Component: (await app()).MobileApp }),
  children: [
    { index: true, lazy: async () => ({ Component: (await app()).TicketsPage }) },
    { path: 'tickets/:id', lazy: async () => ({ Component: (await app()).TicketPage }) },
    { path: 'schedule', lazy: async () => ({ Component: (await app()).SchedulePage }) },
    { path: 'orgs', lazy: async () => ({ Component: (await app()).OrgsPage }) },
    { path: 'orgs/:orgId', lazy: async () => ({ Component: (await app()).OrgPage }) },
    { path: 'me', lazy: async () => ({ Component: (await app()).MePage }) },
    { path: '*', lazy: async () => ({ Component: (await app()).TicketsPage }) },
  ],
};
